/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

interface StatusProps {
  status?: 'C' | 'F' | 'E' | 'B' | 'P';
}

const StatusVariations = {
  C: css`
    background: var(--green);
  `,
  E: css`
    background: var(--orange);
  `,
  F: css`
    background: var(--green);
  `,
  B: css`
    background: var(--yellow);
  `,
  P: css`
    background: var(--purple);
  `,
};

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
  }

  .TitleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media only screen and (max-width: 768px) {
      justify-content: center;
    }
  }

  .inputContainer {
    display: flex;
    align-items: center;

    div {
      height: 0;
      width: 120px;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--green);
      color: var(--white);
      padding: 3px;
      width: 50px;
      height: 40px;
      margin-left: 5px;
      border-radius: 8px;
      transition: background 0.3s ease;

      &:hover {
        background: #4e8e20;
      }
    }
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;
  display: flex;
  color: var(--orange);
  margin-top: -10px;
  margin-bottom: -10px;

  align-items: center;
  justify-content: space-between;
  width: 100%;

  .title {
    font-size: 45px;
    color: var(--orange);
    display: flex;
    justify-content: space-between;
    @media only screen and (max-width: 768px) {
      justify-content: center;
      flex-direction: column-reverse;
    }
  }

  @media only screen and (max-width: 768px) {
    margin-top: -25px;
  }
`;

export const SubTitle = styled.h3`
  color: var(--purple);
  font-size: 20px;
`;

export const DataContainer = styled.div`
  display: flex;
  @media only screen and (max-width: 767px) {
    margin-left: 0px;
    display: grid;
  }
`;

export const DataContainerRecharge = styled.div`
  padding: 50px;
  h1 {
    color: var(--orange);
  }
  h2 {
    color: var(--purple);
  }
`;

export const Card = styled.div`
  box-shadow: var(--box-shadow);
  padding: 15px;
  background: var(--aside-background);
  border-radius: 20px;
  width: 100%;
  @media only screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;

export const ButtonInitial = styled.div`
  button {
    width: 180px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    margin-right: 10px;
    transition: background 0.3s ease;
  }

  .boleto {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 17px 17px;
    font-size: 0.9rem;
    transition: background 0.3s ease;
    border: 2px solid var(--purple);
    &:hover {
      background: var(--white);
      color: var(--purple);
      border: 2px solid var(--purple);
    }
  }

  .pedido {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 17px 17px;
    font-size: 0.9rem;
    transition: background 0.3s ease;
    border: 2px solid var(--purple);
    &:hover {
      background: var(--white);
      color: var(--purple);
      border: 2px solid var(--purple);
    }
  }
  .finalizar {
    justify-content: center;
    border: 2px solid var(--purple);
    &:hover {
      background: var(--white);
      color: var(--purple);
      border: 2px solid var(--purple);
    }
  }
  .remove {
    border-radius: 17px 17px;
    font-size: 0.9rem;
    background: transparent;
    color: var(--purple);
    border: 2px solid var(--purple);
    justify-content: center;
    &:hover {
      background: var(--purple);
      color: var(--white);
      border: 2px solid var(--purple);
    }
  }

  @media only screen and (max-width: 768px) {
    margin-top: 35px;
    justify-content: center;
    align-items: center;
    align-self: center;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 140px;
  }
`;

export const ButtonsContainer = styled.div`
  margin-top: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StatusRow = styled.div<StatusProps>`
  color: var(--white);
  width: 130px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  ${props => StatusVariations[props.status || 'C']}
`;

export const ServicedEmployees = styled.div`
  .saveall{
    margin-right: 20%;
    @media only screen and (max-width: 1000px) {
      margin-right: 10%;
    }

    @media only screen and (max-width: 900px) {
      margin-right: 1%;
    }
  }
`;
